export enum AuthenticationStatus {
  AUTHENTICATED = 'AUTHENTICATED',
  SIGN_IN = 'SIGN_IN',
}
